
import { CACHE_KEY_PREFIX, CACHE_KEY_USER_SUFFIX, COOKIES_KEY_PREFIX } from '../../constants';
import type { AuthObject } from '@white-label-types/auth';
import type { Context } from '@white-label-types/global-context';

export const clearStorageForInactiveSessionWrapper = (
	app: Context['app'],
	authInstance: AuthObject
) => {
	const isAuth0SessionActive = app.$cookies.get(`${COOKIES_KEY_PREFIX}.${authInstance.clientId}.is.authenticated`);

	// Check if there's a mismatch between Auth0's session (cookie-based) and app's state
	// - `!isAuth0Authenticated`: Auth0 cookie is missing, meaning Auth0 considers the user logged out.
	// - `this.isAuthenticated`: App's state (@auth0/auth0-spa-js plugin) still thinks the user is logged in.
	if (!isAuth0SessionActive && authInstance.isAuthenticated) {
		// Clear local storage to ensure full logout all subdomains
		localStorage.removeItem(`${CACHE_KEY_PREFIX}::${authInstance.clientId}::${authInstance.audience}::openid profile email`);
		localStorage.removeItem(`${CACHE_KEY_PREFIX}::${authInstance.clientId}::${CACHE_KEY_USER_SUFFIX}`);
	}
}
